import React from 'react'
import formatNumber from '@i18n/formatNumber'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function Balance(props) {
  const {config, me} = props
  const {t} = useTranslation('website', {keyPrefix: 'redeem.balance'})

  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <div className={styles.balance}>{formatNumber(me.balance, '0,0.[00]')}</div>
        <div className={styles.text}>{t('labelBalance', {name: config.name})}</div>
      </div>
    </div>
  )
}
